import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';

export default css({
  '&.creator-file-overlay-icons': {
    borderRadius: '3px',
    padding: '0 0 0 5px',
    alignItems: 'center',
    '&--gallery:has(svg)': {
      backgroundColor: `${COLORS.BLACK}75`,
    },
    '&--gallery .creator-file-overlay-icons__icon': {
      color: COLORS.WHITE,
    },
    '&--list .creator-file-overlay-icons__icon': {
      color: `${COLORS.BLACK}A0`,
    },
  },
  '.creator-file-overlay-icons': {
    '&__icon': {
      paddingRight: '5px',
    },
  },
});
